const a = Object.freeze({
  klarna: "Klarna",
  paypal: "PayPal"
});
function s(r, i) {
  return r.lastFourDigits ? i === "detail" ? "•••• •••• •••• " + r.lastFourDigits : r.lastFourDigits : r.description || a[r.type] || r.type;
}
export {
  s as parsePaymentMethodType
};
